import { create } from 'zustand';

interface RcCredentialsStore {
  token: string;
  userId: string;
  setCredentials: (token: string, userId: string) => void;
  clearCredentials: () => void;
}

// Credentials live only in memory — never written to localStorage.
// XSS can read localStorage; it cannot read this module's closure.
export const useRcCredentials = create<RcCredentialsStore>((set) => ({
  token: '',
  userId: '',
  setCredentials: (token, userId) => set({ token, userId }),
  clearCredentials: () => set({ token: '', userId: '' }),
}));

// Non-reactive helpers for use outside React components (services, stores).
export const getRcToken = (): string => useRcCredentials.getState().token;
export const getRcUserId = (): string => useRcCredentials.getState().userId;
export const setRcCredentials = (token: string, userId: string): void =>
  useRcCredentials.getState().setCredentials(token, userId);
export const clearRcCredentials = (): void => useRcCredentials.getState().clearCredentials();
